import React from 'react';
import { motion } from 'framer-motion';
export function Pain() {
  return <section className="bg-forest py-20 md:py-28" data-id="element-144">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-146">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-warm-white mb-12 text-center" data-id="element-147">
            Es frustrante.
          </h2>

          <div className="space-y-8 text-warm-white/90 text-lg md:text-xl leading-relaxed" data-id="element-148">
            <p data-id="element-149">
              Eres una mujer que ha logrado grandes cosas. Llevas adelante una
              carrera, una familia, una vida compleja. Pero de repente, las
              reglas del juego cambiaron.
            </p>

            <p data-id="element-150">
              Intentas comer menos, pero lo único que consigues es estar más
              irritable y con más "niebla mental". Intentas hacer más cardio,
              pero tu cuerpo responde hinchándose más.
            </p>

            <div className="border-l-4 border-gold-light pl-6 my-10" data-id="element-151">
              <p className="font-serif text-2xl md:text-3xl italic text-gold-light" data-id="element-152">
                La industria de la dieta te dice que "comas menos y te esfuerces
                más", pero a los 45 años, ese consejo es veneno puro.
              </p>
            </div>

            <p data-id="element-153">
              Solo eleva tu cortisol, bloquea tu tiroides y le ordena a tu
              cuerpo:{' '}
              <strong data-id="element-154">
                "Guarda toda la grasa que puedas porque estamos en peligro"
              </strong>
              .
            </p>

            <p className="text-xl md:text-2xl font-semibold text-warm-white" data-id="element-155">
              Estás atrapada en un ciclo de supervivencia, no de salud.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}